import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { add, startOfWeek } from 'date-fns';
import DayPicker from 'react-day-picker';
import 'react-day-picker/lib/style.css';

function getWeekDays(weekStart) {
  const date = new Date(weekStart);
  const days = [date];
  for (let i = 1; i < 5; i += 1) {
    days.push(add(date, { days: i }));
  }
  return days;
}

function getWeekRange(date) {
  const d = new Date(date);
  const from = startOfWeek(d, { weekStartsOn: 1 });
  return {
    from,
    to: add(from, { days: 4 }),
  };
}
const DayPickerWrapper = ({
  initialFromValue,
  startDate,
  onDateChange = null,
}) => {
  const [selectedDays, setSelectedDays] = useState(
    initialFromValue ? getWeekDays(initialFromValue) : []
  );
  const [hoverRange, setHoverRange] = useState(undefined);

  const handleDayChange = date => {
    const weekRange = getWeekRange(date);
    if (weekRange.from < startDate) {
      return;
    }
    setSelectedDays(getWeekDays(weekRange.from));
    if (onDateChange) {
      onDateChange({
        startDate: weekRange.from,
        endDate: weekRange.to,
      });
    }
  };

  const handleDayEnter = date => {
    setHoverRange(getWeekRange(date));
  };

  const handleDayLeave = () => {
    setHoverRange(undefined);
  };

  const handleWeekClick = (weekNumber, days) => {
    setSelectedDays(days);
  };

  const daysAreSelected = selectedDays.length > 0;
  const modifiers =
    hoverRange && hoverRange.from >= startDate
      ? {
          hoverRange,
          selectedRange: daysAreSelected && {
            from: selectedDays[0],
            to: selectedDays[4],
          },
          hoverRangeStart: hoverRange && hoverRange.from,
          hoverRangeEnd: hoverRange && hoverRange.to,
          selectedRangeStart: daysAreSelected && selectedDays[0],
          selectedRangeEnd: daysAreSelected && selectedDays[4],
        }
      : null;

  return (
    <div className="SelectedWeekDatePicker [&_.DayPicker-Month]:border-separate [&_.DayPicker-WeekNumber]:outline-[none] [&_.DayPicker-Day]:outline-[none] [&_.DayPicker-Day]:border-[1px] [&_.DayPicker-Day]:border-solid [&_.DayPicker-Day]:border-transparent [&_.DayPicker-Day--hoverRange]:!bg-[#EFEFEF] [&_.DayPicker-Day--hoverRange]:hover:!rounded-none">
      <DayPicker
        month={selectedDays[0] || startDate}
        disabledDays={[{ before: startDate }]}
        selectedDays={selectedDays}
        showWeekNumbers
        showOutsideDays
        modifiers={modifiers}
        onDayClick={handleDayChange}
        onDayMouseEnter={handleDayEnter}
        onDayMouseLeave={handleDayLeave}
        onWeekClick={handleWeekClick}
      />
    </div>
  );
};

DayPickerWrapper.propTypes = {
  initialFromValue: PropTypes.instanceOf(Date),
  onDateChange: PropTypes.func,
  startDate: PropTypes.instanceOf(Date).isRequired,
};

export default DayPickerWrapper;
